import * as React from 'react';
import * as after from './style.module.scss';
import * as main from "../../../styles/main.module.scss";
export const After = ({ btnText="Записаться на курс", btnAnchor="#cost" }) => {
  return (
    <section className={`${after.after} container`}>
      <div className={after.after__block}>
        <div className={after.after__infoBlock}>
          <h2 className={after.after__title}>
            После прохождения курса Вы:
          </h2>
          <ul>
            <li className={after.after__item}>
              <p>
                сможете <span className={main.bgPurple}> держать в голове </span> всю нужную информацию;
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                будете <span className={main.bgPurple}> в 2 раза лучше запоминать </span> информацию из&nbsp;прочитанных книг и
                просмотренных фильмов;
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                сможете запоминать <span className={main.bgPurple}> от 100 новых слов в час</span>;
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                <span className={main.bgPurple}>перестанете уставать </span> после рабочего дня;
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                <span className={main.bgPurple}>научитесь концентрировать</span> своё внимание на новой, сложной информации;
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                получите <span className={main.bgPurple}> более 150 часов в год </span> свободного времени, которое раньше
                уходило на запоминание, перечитывание и т.д.;
              </p>
            </li>
          </ul>
        </div>
        <img
          src="https://fs.advance.ru/landing-pages/course/kurs-razvitiya-pamyaty/photo-krp-1.png"
          alt=""
          className={after.after__img}
        />
      </div>
      <div className={`${after.after__block} ${after.after__blockSec}`}>
        <div className={after.after__infoBlock}>
          <h2 className={after.after__title}>
            А ещё:
          </h2>
          <ul>
            <li className={after.after__item}>
              <p>
                <span className={main.bgPurple}>перестанете забывать слова</span> во время разговора;
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                станете <span className={main.bgPurple}>помогать с учебой</span> своим детям и внукам;
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                будете <span className={main.bgPurple}>держать в голове номера</span> телефонов и&nbsp;дни&nbsp;рождения всех родных и
                друзей;
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                сможете <span className={main.bgPurple}> освоить новую профессию;</span>
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                <span className={main.bgPurple}> удивите близких </span> своей памятью;
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                начнете <span className={main.bgPurple}>быстро запоминать</span> иностранные слова;
              </p>
            </li>
            <li className={after.after__item}>
              <p>
                <span className={main.bgPurple}>...и многое другое!</span>
              </p>
            </li>
          </ul>
        </div>
        <img
          src="https://fs.advance.ru/landing-pages/course/kurs-razvitiya-pamyaty/photo-krp-2.png"
          alt=""
          className={after.after__img}
        />
      </div>
      <a href={ btnAnchor } className={`${main.mainBtnRound} ${after.after__btn}`}> { btnText } </a>
    </section>
  );
};
